/**
 * /creators/promo — creator promo codes page.
 *
 * Declares a TanStack Router route and renders the composed
 * `CreatorPromoPage`. The route is auto-wired by the root `router.tsx`
 * registry after this branch lands on prod-main — the page stays in the
 * feature module so this file is the thinnest possible shell.
 *
 * A `?influencerId=` deep-link is reserved so operators can land on the
 * page pre-filtered from a creator detail view.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { CreatorPromoPage } from "@/features/creator-promo/CreatorPromoPage";

// ---------------------------------------------------------------------------
// Route — mounts at `/creators/promo`.
// ---------------------------------------------------------------------------

interface CreatorsPromoSearch {
	influencerId?: string;
}

export const creatorsPromoRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creators/promo",
	validateSearch: (raw: Record<string, unknown>): CreatorsPromoSearch => {
		const influencerId = raw.influencerId;
		if (typeof influencerId === "string" && influencerId.trim().length > 0) {
			return { influencerId: influencerId.trim() };
		}
		return {};
	},
	component: CreatorsPromoRoute,
});

export default creatorsPromoRoute;

// ---------------------------------------------------------------------------
// Route component — forwards the deep-linked influencer id to the page.
// ---------------------------------------------------------------------------

export function CreatorsPromoRoute() {
	const { influencerId } = creatorsPromoRoute.useSearch();
	return <CreatorPromoPage initialInfluencerId={influencerId} />;
}

// Named export aligned with existing dash page naming (used by the root
// wire-up when it imports + registers the route).
export { CreatorPromoPage as CreatorsPromoPage };
